import { useUserStore } from '@/store/user'
import { createRouter, type RouteRecordRaw, createWebHistory } from 'vue-router'
import { featureRoutes } from '@/modules'
import { requireAuthAndRole } from './Guard'
import { breadcrumbGuard } from './BreadCrumbGuard'

const routes: RouteRecordRaw[] = [...featureRoutes]
const router = createRouter({
  history: createWebHistory(),
  routes,
})

//guard routes
router.beforeEach(requireAuthAndRole)
router.beforeEach(breadcrumbGuard)

export default router
